type SectionHeadingProps = {
  id?: string;
  eyebrow?: string;
  title: string;
  intro?: string;
  align?: 'left' | 'center';
};

export function SectionHeading({ id, eyebrow, title, intro, align = 'left' }: SectionHeadingProps) {
  return (
    <div className={`section-heading section-heading--${align}`}>
      {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
      <h2 id={id}>{title}</h2>
      {intro ? <p>{intro}</p> : null}
    </div>
  );
}
